import React from 'react';
import { Input } from 'baseui/input';
const ScrollResistantNumberInput = props => {
  // Prevents number input from being changed by mouse wheel or trackpad scroll

  const handleWheel = event => {
    event.target.blur();
  };
  return <Input type="number" onWheel={handleWheel} overrides={{
    Root: {
      style: {
        'input::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0
        },
        'input::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0
        },
        'input[type=number]': {
          '-moz-appearance': 'textfield'
        }
      }
    },
    Input: {
      props: {
        onMouseEnter: e => e.target.focus(),
        'data-testid': 'scroll_resistant_number_input'
      }
    }
  }} {...props} />;
};
export default ScrollResistantNumberInput;